<template>
  <section>
    <div id ="landing">
    <v-container v-if="newAwsAcctInternalClient.registrationStep === 'internaltype'">
      <v-form>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 xl12 class="margin-bottom-5">
            <v-select 
            :items="filteredInternalCustomers"
            :item-text="(item) => `${item.Customer_Name} - ${item.Customer_Region}`"
            item-value="Customer_Id"
            label="DXC Internal Region"
            placeholder="Select Internal Region"
            v-model="newAwsAcctInternalClient.workload.fields.Customer_Id"
            @change="onCustomerChange"
            attach
           :loading="newAwsAcctInternalClient.loadingCustomers"
            >
             <template slot="label">
                      <span v-html="`<span style='font-size:18px'>DXC Internal Region<span style='color:red' class='required'>*</span></span>`"/>
                    </template>
            </v-select>
          </v-flex>
          <v-flex>
            <ul>
              <li>Ensure your workload is internal. Your attestation is required on the next page to validate the internal workload.</li>
              <li>All internal workloads do not need opportunity registration and they automatically qualify for 21% discount off AWS published list, which is the DXC PPA discount tier.</li>
              <li>Download and read the “Internal/External Definition” document. To download, click on “View Guides” in the left column to select.</li>
              <li>Click the “Get Internal ID” button below to generate your Internal OppReg ID for this workload. This ID is used for DXC Onboarding process and Account Inventory records.</li>
            </ul>
            <v-btn color="warning" @click="generateInternalId" :loading="newAwsAcctInternalClient.generatingOppId">GET INTERNAL ID</v-btn> &nbsp; <span><strong>{{newAwsAcctInternalClient.oppId}}</strong></span>
          </v-flex>
          <v-flex xs12 sm12 md12 xl12 class="margin-bottom-5 text-md-right">
            <v-btn @click="goToAwsOppRegistration" color="warning" 
            :disabled="!newAwsAcctInternalClient.oppId || !newAwsAcctInternalClient.workload.fields.Customer_Id">Next</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    </div>

    
    <formUserAwsOppRegistration
      v-if="newAwsAcctInternalClient.registrationStep === 'oppreg'" 
      :type="'Internal'"
      @cancel="onAwsValidationCancel"
       @previous="goBackToListing"
      @save-for-later="onAwsValidationSaveForLater"
      @submit="onAwsValidationSubmit" />


    <formUserAwsAcctValidation
      v-if="newAwsAcctInternalClient.registrationStep === 'validation'" 
      :type="'Internal'"
      @cancel="onAwsValidationCancel"
      @previous="goToAwsOppRegistration"
      @save-for-later="onAwsValidationSaveForLater"
      @submit="onAwsValidationSubmit" />

    <formReqAwsQuestionnaire
      v-if="newAwsAcctInternalClient.registrationStep === 'onboarding'"
      :type="'Internal'"
      @previous="goBackToValidation"
      @continue="onOnboardingSubmit" />

    <formReqAwsContact
      v-if="newAwsAcctInternalClient.registrationStep === 'contact'"
      :type="'Internal'"
      @go-to-onboarding="goBackToQuestionnaire"
      @reset="onReset"
      @save="onContactsSave"/>

  </section>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      awsType: '', 
      isDisclaimer: false, 
      dxcInternalRegion: null
    }
  },
  mounted () {
    this.$store.dispatch('user/requestAws/getCustomers', 'internal')
    this.$store.commit('user/requestAws/setInternalRegistrationStep', 'internaltype')
    // this.$store.commit('user/requestAws/clearInternalAccount')
    // this.$store.commit('user/requestAws/clearInternalAwsAcctValidation')
    // this.$store.commit('user/requestAws/clearInternalAwsOnboarding')
    // this.$store.commit('user/requestAws/clearInternalAwsOnboardingContacts')
  },
  unmounted() {
    this.$store.commit('user/requestAws/clearInternalAccount')
    this.$store.commit('user/requestAws/clearInternalAwsAcctValidation')
    this.$store.commit('user/requestAws/clearInternalAwsOnboarding')
    this.$store.commit('user/requestAws/clearInternalAwsOnboardingContacts')
  },
  computed: {
  ...mapState('user/requestAws', ["newAwsAcctInternalClient","awsAccountOnboarding"]),
    filteredInternalCustomers () {
      const allowedRegions = [
        'DXC Internal - Americas',
        'DXC Internal - UKI',
        'DXC Internal - Europe',
        'DXC Internal - APJ-MEA'
      ]

      return this.newAwsAcctInternalClient.customers.filter((customer) => {
        const label = `${customer.Customer_Name} - ${customer.Customer_Region}`
        return allowedRegions.includes(label)
      })
    },
    filterWorkloads(){
      let workloadStatus = ['Approved - Tier 1 23% - PPA', 'Approved - Tier 3 12%','Approved - Tier 2 - Custom EDP']
      return this.newAwsAcctInternalClient.workloads.filter(workload => workloadStatus.includes(workload.Workload_Status)) 
    }
  },
  beforeDestroy () {
  },
  methods: {
    onCustomerChange(){
      this.$store.commit('user/requestAws/clearInternalOppId')
      this.$store.commit('user/requestAws/clearInternalProjectId')
      this.$store.commit('user/requestAws/clearInternalContact')
      this.$store.commit('user/requestAws/clearInternalWorkload')

      let [selectedCustomerAlias] = this.newAwsAcctInternalClient.customers.filter(workload => workload.Customer_Id == this.newAwsAcctInternalClient.workload.fields.Customer_Id)
      this.$store.commit('user/requestAws/setInternalCustomerAlias', selectedCustomerAlias.Customer_Alias)
      this.$store.commit('user/requestAws/setWorkloadCustomer', selectedCustomerAlias)
      this.$store.commit('user/requestAws/setInternalOnboardCustomerId', this.newAwsAcctInternalClient.workload.fields.Customer_Id)
    },
    hasInternalOppregId(){
      if(this.newAwsAcctInternalClient.hasInternalOppregId === 'N'){
        this.$store.commit('user/requestAws/clearOppregId')
        this.$store.commit(
        'showDialog',
        {
          show: true,
          type: 'confirmation',
          persistent: true,
          title: 'This new workload must be registered to proceed.',
          yesLabel: 'Proceed to Opportunity Registration',
          yesHandler: () => {
            vm.$router.push({ path: `/request-oppreg/external-oppreg` })
             this.$store.commit('showDialog', { show: false })
          },
          noHandler: () => {
            this.$store.commit('showDialog', { show: false })
          },
          noLabel: 'Close'
        },
        { root: true }
      )
      }
    }, 

    onOppIdValidate(){
      this.isDisclaimer = false
      if(this.newAwsAcctInternalClient.oppId !== ''){
        let keyword = ['DXCINT', 'DXCSUB','DXCGNW']
        let oppId = this.newAwsAcctInternalClient.oppId
        console.log ('Opp ID: '+ oppId.substring(0,5))
        let substring = oppId.substring(0,5)
        if(oppId.includes('DXCINT') || oppId.includes('DXCSUB') || oppId.includes('DXCGNW')){
           let obj = {
            awsType: 'internal',
            oppId: this.newAwsAcctInternalClient.oppId
          }
          this.$store.dispatch('user/requestAws/onOppIdValidate', obj )
        } else {
          this.$store.commit('user/requestAws/setOppRegIdAvailabilityMessage', { awsType: 'internal', type:'error',  message: 'You entered a non DXC Internal/Gainwell Opportunity Id'})
        }
      } else {
        this.$store.commit('user/requestAws/setOppRegIdAvailabilityMessage', { awsType: 'internal', type:'error',  message: 'Opportunity Registration ID is empty'})
      }
      
    },
    validateProjectId(){
      console.log('selected Project ID::::', this.awsAccountOnboarding.fields.Project_Id)
      let selectedWorkload = this.newAwsAcctInternalClient.workloads.filter(workload => workload.Project_Id === this.awsAccountOnboarding.fields.Project_Id)
      let workload = selectedWorkload[0].Workload_Status
      let workloadStatus = ['Approved - Tier 1 23% - PPA','Approved - Tier 1 23% - PPA SaaS','Approved - Tier 3 12%','Approved - Tier 2 - Custom EDP']
      if(!workloadStatus.includes(workload)){
        this.isDisclaimer = true
      } else {
        this.isDisclaimer = false
      }
    },
    goBackToListing () {
      this.$store.commit('user/requestAws/setInternalRegistrationStep', 'internaltype')
    },

    goToAwsOppRegistration () {
      this.$store.commit('user/requestAws/setInternalRegistrationStep','oppreg')
    },

    goToAwsValidation(){
      this.$store.commit('user/requestAws/setInternalRegistrationStep','validation')
    },
    onAwsValidationCancel () {
      // event for cancel aws validation button
      this.$store.commit('user/requestAws/clearValidation')
      this.$store.commit('user/requestAws/setInternalRegistrationStep', 'listing')
    },

    goBackToValidation () {
      this.$store.commit('user/requestAws/setInternalRegistrationStep', 'validation')
    },
    goBackToQuestionnaire () {
      this.$store.commit('user/requestAws/setInternalRegistrationStep', 'onboarding')
    },
    onAwsValidationSaveForLater (data) {
      // event for save for later aws validation button
      // this.$store.state['user/requestAws'].newAwsAccount.accountRecord.onboarding
      // here we dispatch the onboarding-header record creation
      this.$store.dispatch('user/requestAws/createOnboardingAccount',
        this.$store.state['user/requestAws'].newAwsAccount.accountRecord.onboarding
      )
    },
    onAwsValidationSubmit (data) {
      // event for submit aws validation button
      // this.$store.dispatch('user/requestAws/insertWbsAndIwoExisting', data)
      this.$store.commit('user/requestAws/setInternalRegistrationStep', 'onboarding')
    },

    onOnboardingSubmit (onboarding) {
      // update onboarding state under Account Record
      this.$store.commit('user/requestAws/updateOnboardingInternal', onboarding)
      this.$store.commit('user/requestAws/setInternalRegistrationStep', 'contact')
    },

    onContactsSave (contacts) {
      this.$store.commit('user/requestAws/updateOnboardingContactsInternal', contacts)
      // here we dispatch the onboarding-header record creation
      this.$store.dispatch('user/requestAws/createOnboardingAccount', 
       { 
         record: this.$store.state['user/requestAws'].newAwsAcctInternalClient.accountRecord.onboarding,
         oppregStatus: this.$store.state['user/requestAws'].newAwsAcctInternalClient.oppregStatus,
         custName: this.$store.state['user/requestAws'].newAwsAcctInternalClient.custName,
        //  // AGAM-1525, set default master payer for internal and training account registration
        //  mpid: '547609375576',
         type: 'internal'
       } 
      )
    },

    goToAwsValidation() {
      let selectedDxcRegion = this.awsAccountOnboarding.fields.Customer_Id
      let dxcRegion = this.newAwsAcctInternalClient.customers.filter(res => {
        if (res.Customer_Id === selectedDxcRegion) {
          return res.Customer_Region
        }
      } 
      )
      this.$store.commit('user/requestAws/setInternalDxcRegion', dxcRegion[0].Customer_Region)
      this.$store.commit('user/requestAws/setInternalCustomer', dxcRegion[0].Customer_Name)
      this.$store.commit('user/requestAws/setInternalOppregStatus',this.newAwsAcctInternalClient.workloads[0].Workload_Status)
      this.$store.commit('user/requestAws/setInternalRegistrationStep','validation')
    },

    onReset () {
      this.$store.commit('user/requestAws/clearInternalAccount')
      // clear AWSAccount validation State
      this.$store.commit('user/requestAws/clearInternalAwsAcctValidation')
      this.$store.commit('user/requestAws/clearInternalAwsOnboarding')
      this.$store.commit('user/requestAws/clearInternalAwsOnboardingContacts')
    },

    generateInternalId () {
      this.$store.dispatch('user/requestAws/generateId', 'internal')
    }
  }
}
</script>
<style style="scss" scoped>
 #landing {
    margin: 15px 15px;
    /* height: 100%; */
    background-color: #ffffff;
 }

 #landing > .container {
   padding:25px 25px
 }
 margin-bottom-5{
   margin-bottom:5px
 }
 .padding-10-15 {
   padding:10px 15px
 }
 .note {
    font-size: 14px !important;
    margin: 0 0 10px;
    background-color: #ff9900;
    color: #000;
    padding: 15px 15px;
    margin: 15px 0;
}
.note > span {font-weight:500}
.v-btn-toggle .v-btn.v-btn--active{
    background-color: #ff9900 !important;
  }
</style>
